import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import Navbar from './Navbar'
import Footer from './Footer'
import axios from "axios";
import keys from "../actions/config";
const url = keys.baseUrl;
class Privacy extends Component {

  constructor(props) {
    super(props);

    this.state = {
        subject:"",
        content: "",
        errors: {},
        privacy : {},
        cmsData:{}
    };

  }

  componentDidMount() {
    window.scrollTo(0, 0);

    this.gettingCmsData();

  };
  gettingCmsData = async () => {

     const data = { identifier: "Privacy Policy" }

    const result = await axios.post(url + "cryptoapi/getSingleCmsData", data);

    const cmsData = result.data.result;
    this.setState({
      cmsData: cmsData
    })

  }
  renderPrivacyPolicyText() {
    return (
      <div className="privacy-policy-content">
        <p className="privacy-policy-text">
        {`
Bell Exchange (hereinafter Bell Exchange or “we”) regards as of paramount importance the protection and security of information about you. The purpose of this Privacy Policy is to inform you about how we use your Data, the security measures we implement to ensure their integrity and the rights you have to control the use of your Data.

The Privacy Policy is applicable in the existing relationship between you, User of our Website and Ledger, owner and publisher of the Website. This Privacy Policy applies to the use of any Data we collect or that you provide to us in connection with your use of our Website. We encourage you to read it carefully.

DEFINITIONS AND INTERPRETATION

In this privacy policy, the following definitions are used:
DATA
Collectively, the information that user use to submit to the website bitbaazii.

PERSONAL DATA
Collectively, all information making you directly or indirectly identifiable (e.g. your name, first name, address, phone number or email address but also the IP address of your computer, for example, or the information relating to your browsing of our Website).

COOKIES
A small text file placed on your computer by our Website when you visit certain parts of the Website and/or when you use certain features of the Website. Please refer to the Cookie Policy for more information.

PERSONAL DATA CONTROLLER
The processing of any personal data provided or collected on the Website is carried out under the supervision of Bell Exchange SAS whose head office is located at VENUE NAME, JAPAN.

GDPR
The “General Data Protection Regulation” (EU Regulation 2016/679), as well as any national legislation adopted in accordance therewith.

E-PRIVACY DIRECTIVE
As per the country regulations on the data privacy concerning the processing of personal data and the protection of privacy in the electronic communications sector, as well as any national legislation adopted in accordance therewith;

USER OR YOU
Any Internet user who accesses the Website and who is neither
(i) employed by Bell Exchange and acting in the course of his/her employment; nor
(ii) engaged as a consultant or otherwise providing services to Bell Exchange and accessing the Website in connection with the provision of such services;

WEBSITE
The following website: www.bitbaazi.com and all subdomains of these Websites, unless they are expressly excluded from the scope of this Policy by their own terms and conditions

In this Privacy Policy, unless the context requires a different interpretation:
The singular includes the plural and vice versa;
References to sections, clauses, appendices refer to the sections, clauses, appendices of this Privacy Policy;
A reference to a person includes firms, companies, government entities, trusts, and partnerships;
“Including” means “including but not limited to”;
A reference to any legislative provision includes all amendments thereto;
Headings and subheadings are not part of this Privacy Policy.
SCOPE OF THIS PRIVACY POLICY

This Privacy Policy applies only to the actions of Bell Exchange and of Users with respect to our Website. It does not extend to websites that can be accessed from our Website, including, but not limited to, any links we may provide to social media websites.
USE OF PERSONAL DATA

When you purchase products or services from our Website, we collect and process the Data that is necessary for the follow-up of our contractual relationship.
For this purpose, we use the information you provide us with:

To handle orders,
To deliver our products and/or provide our services,
To process invoices, payments and transactions history,
To manage unpaid bills and claims.
Whether you are our customer or simply an Internet user viewing the pages of our Website, we may also process your Data to meet our legitimate interests, consisting of:
Communicating with you about our products and services and send you our promotional offers;
Developing our products and services further;
Continuously improving our Websites and offering you a more enjoyable and efficient shopping experience.
The use of the data we collect is, if so, subject to your consent to receive our marketing offers and/or those of our partners electronically (by email or SMS).
Depending on the purposes stated above, we may collect the following types of information:

– Information that you provide us with: When you purchase a product or service from Bitbaazi, we collect, as part of the buying and selling process, the personal information you submit during your purchase, including:

Your surname and first name;
Your contact information such as your address, e-mail and telephone numbers;
Your financial information such as your credit/debit card number.
– Information resulting from your activity on our Website: We receive and store certain types of information every time you interact with us. For example, like many websites, we use Cookies and we obtain certain types of information when your Web browser accesses our Websites and other content provided by or on behalf of Ledger on other websites. We may therefore also collect the following Data from you:

IP address (automatically collected);
Web browser type and version (automatically collected);
Operating system (automatically collected);
Your browsing history to and from the Website;
In each case, in accordance with this Privacy Policy.

For more information on the collection and use of such Data, please check our Cookie Policy.

RETENTION OF PERSONAL DATA

The retention period of Personal Data processed by Bell Exchange may vary depending on common practice, the documents considered in accordance with the legal obligations and the applicable limitation rules.
With regard to credit card data, Bell Exchange uses payment services providers that manage transaction data in accordance with strict security rules applicable to online payments via encryption methods.

All Personal Data is securely stored on our servers in accordance with industry standards and the GDPR. For more details on the security measures implemented, please refer to the section “Security” below
RECIPIENTS OF PERSONAL DATA

We transmit your Data to our employees who are authorized to process them as part of their duties.
We may also transmit some of your data to our technical and logistic service providers
acting on our behalf, and we ensure that they provide for the necessary guarantees
with respect to the GDPR.

To allow access to certain payment methods, we use third party providers that may also collect Personal Data. In this case, such service providers are responsible for the collection and processing of Data for the provision of the service. Please refer, if necessary, to their own privacy policy.
All Personal Data used by these third parties is solely used for the purposes of the services provided at our request. Any use for other purposes is strictly prohibited. In addition, any Personal Data processed by third parties will be in accordance with the terms of this Privacy Policy and in compliance with the GDPR. The third party providers we use will only collect, use and disclose your information to the extent necessary to enable them to perform the services they provide to us.
In certain circumstances and where required by law, we may transmit your data to competent administrative or judicial authorities or any other authorized third party.
LINKS TO OTHER WEBSITES

Our Website may, from time to time, provide links to other websites. We have no control over such websites and we are not responsible for their content. This Privacy Policy does not extend to the use of such websites. We advise you to read the privacy policy or charter applicable to such other websites before using them.
YOUR RIGHTS REGARDING THE USE OF YOUR PERSONAL DATA

When you provide us with your Personal Data, you stay in control of such Personal Data and have the option to limit their use.
This limitation may concern:

The use of Personal Data for direct marketing purposes, which are subject to the opt-in rule; and
The sharing of Personal Data with third parties.
You have the right to request access to your Personal Data, their rectification or erasure, as well as the right to request the restriction of the processing or to object to the processing.
You also have the right to withdraw your consent at any time, in particular to have your data no longer processed for the purpose of marketing by electronic means.

In the event that you believe that our use of your Personal Data violates the rules on personal data protection, you may file a complaint with the respective department.

You also have the right to set general or specific guidelines regarding the fate of your personal data in the event of death. Your specific guidelines can be directly sent to the address below. They can also be registered with a digital trusted third party certified by the Govt. You have the option to modify or delete such guidelines at any time.

You also have the right to request a copy, in an interoperable format, of the Personal Data that you have provided to us.

You can address your requests to: privacy@bitbbazi.com.

Your requests must be accompanied by a copy of a proof of identity and will be reviewed by our services as soon as possible.

For more information on how to access your Personal Data and to exercise your rights, please contact us (see contact information at the end of this Privacy Policy).

FUNCTIONALITY OF THE WEBSITE

In order to use all the resources and features available on our Website, you may be required to transmit certain Personal Data to us.
You may restrict the use of Cookies in your Web browser. For more information, please refer to our Cookie Policy.
PERSONAL DATA SECURITY

Personal Data security is of great importance to Bitbaazi. In order to protect your Personal Data, we have implemented appropriate physical, electronic and organizational procedures to safeguard and secure the Personal Data collected via our Website in order to ensure its integrity and confidentiality.
If a password is required to access certain sections of our Website, you are responsible for keeping this password confidential.
We endeavor to do all we can to protect your Personal Data. However, the transmission of information on the Internet is not fully secure and remains under your sole responsibility. We cannot ensure the security of the transmission of your Data to our Website.
Payment Security: If you provide us with credit card information, such information is encrypted using a secure Internet Trade Protocol (TLS) and sent directly to our banking service provider. This information is never stored on our server.
TRANSFERS OUTSIDE THE REGIONAL ECONOMIC AREA

Personal Data that we collect from you may be stored and processed in, and transferred to, countries outside the Regional Economic Area (REA). For example, this could happen if our servers are located in a country outside the REA or if one of our service providers is located in a country outside the REA. These countries may not have data protection laws equivalent to those in force in the REA.
If we transfer Personal Data outside the REA this way, we will take the necessary steps to ensure that your Personal Data continues to be protected in compliance with the GDPR, notably by only transferring your Personal Data to businesses established in countries recognized by the Commission as providing an adequate level of protection for your Personal Data or on servers of American companies that are members of the Privacy Shield or organizations that have concluded standard contractual clauses or that commit themselves to applying a code of conduct or a certification mechanism validated by the competent country authorities.
For more information on the safeguards put in place, please contact us.

MISCELLANEOUS

If a court or competent authority considers that any provision of this Privacy Policy (or any part thereof) is invalid, illegal or unenforceable, that provision or relevant part of the provision will, to the extent required, be deemed to be deleted. The validity and enforceability of the other provisions of this Privacy Policy will not be affected.
Unless otherwise agreed, no delay, act or omission by a party in exercising a right or remedy will be deemed a waiver of such right, or of another right or remedy.
This Privacy Policy will be governed by and interpreted according to law. Any dispute arising out of this Privacy Policy will be subject to the exclusive jurisdiction of the courts.
OUR COMMITMENT TO YOUR PRIVACY

We can assure you that we comply with the GDPR and that we process your Data lawfully, fairly and transparently.
We take confidentiality and privacy issues very seriously. We therefore ensure that your personal information is secure; we communicate our privacy and security guidelines and practices to all our employees and service providers and strictly enforce privacy safeguards within our company.

CHANGES TO THIS PRIVACY POLICY

We reserve the right to make changes to this Privacy Policy as we deem necessary from time to time or as may be required by law. All changes will be posted immediately on our Website and you are deemed to have accepted the new terms of the Privacy Policy when you first use the Website after such changes
If our company is the subject of a corporate transaction such as an acquisition or merger with another company, your information may be transferred to the new owners so that we can continue to sell our products to you.
In the above cases, we will take steps to protect your privacy.
CONTACT INFORMATION

If you wish to access, correct, modify or delete the personal information we have about you, object to their processing, exercise your right to portability, file a complaint or simply obtain more information about the use of your Personal Data, and please contact us by e-mail (privacy@bitbaazi.com) or by mail to botbaazi, Address Here.

All such requests will be promptly examined and a reply will be sent to you by our teams.

Bitbaazi, Tokyo, Japan
          `}</p>

      </div>
    )

  }

  // createMarkup = () => {
  //   return { __html: this.state.privacy.data.content };
  // }

  // getData() {
  //   axios
  //   .get(url+"cryptoapi/privacy")
  //   .then(res => {
  //     this.setState({privacy:res});
  //   })
  //   .catch()
  // }


	render() {
    const { cmsData } = this.state;

    console.log("cmssssssssssssssdataaaaaaaaaaaaa",cmsData)

		return (<div className='bg_strip'>
			<section class="headerCrediantials homeBanner">
	      <Navbar />
	    </section>
      <div className='container py-5'>
			<section className="privacy-policy-container">
      

        {
          cmsData && cmsData.content &&
          ReactHtmlParser(
            cmsData.content
          )
          }

      
			</section>
      </div>
			<Footer />
		</div>
		);
	}
}

export default Privacy
